import {ApiError, Body_send_support, FaqCategory, SupportCategory} from '../types';
import {FAQ_GET, FAQ_GET_CAMPAIGN, SUPPORT_GET, SUPPORT_GET_CAMPAIGN} from './keys';
import {useMutation, useQuery} from 'react-query';

import {HelpService} from '../types/services/HelpService';

export function useGetFaq(initialData: FaqCategory[] | null | undefined) {
    let options = {};
    if (initialData) {
        options = {
            initialData: initialData,
        };
    } else {
        options = {};
    }

    return useQuery(FAQ_GET, HelpService.getFaq, options);
}

export function useGetSupport(initialData: SupportCategory[] | null | undefined) {
    let options = {};
    if (initialData) {
        options = {
            initialData: initialData,
        };
    } else {
        options = {};
    }
    return useQuery(SUPPORT_GET, HelpService.getSupport);
}

export function useSendSupport() {
    return useMutation<boolean, ApiError, Body_send_support>((body: Body_send_support) =>
        HelpService.sendSupport(body)
    );
}

export function useGetCampaignFaq(campaignId: string, initialData?: FaqCategory[] | null) {
    let options = {};
    if (initialData) {
        options = {
            initialData: initialData,
            revalidate: 5,
        };
    }
    return useQuery(
        FAQ_GET_CAMPAIGN + ':' + campaignId,
        () => HelpService.getFaqByCampaign(campaignId),
        options
    );
}

export async function fetchCampaignFaq(campaignId: string) {
    return await HelpService.getFaqByCampaign(campaignId);
}

export function useGetCampaignSupport(
    campaignId: string,
    initialData?: SupportCategory[] | null
) {
    let options = {};
    if (initialData) {
        options = {
            initialData: initialData,
            revalidate: 5,
        };
    }
    return useQuery(
        SUPPORT_GET_CAMPAIGN + ':' + campaignId,
        () => HelpService.getSupportByCampaign(campaignId),
        options
    );
}

export async function fetchCampaignSupport(campaignId: string) {
    return await HelpService.getSupportByCampaign(campaignId);
}

// Server-side fetch functions for getStaticProps/getServerSideProps
const GET_JSON_REQUEST_OPTION = {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
};

export async function fetchCampaignFaqServer(
    campaignId: string,
    serverUrl: string
): Promise<FaqCategory[]> {
    const response = await fetch(
        serverUrl + '/faq/campaign?campaign_id=' + campaignId,
        GET_JSON_REQUEST_OPTION
    );
    return await response.json();
}

// Server-side fetch functions for getStaticProps/getServerSideProps
export async function fetchCampaignSupportServer(
    campaignId: string,
    serverUrl: string
): Promise<SupportCategory[]> {
    const response = await fetch(
        serverUrl + '/support/campaign?campaign_id=' + campaignId,
        GET_JSON_REQUEST_OPTION
    );
    return await response.json();
}
